<template>
  <div class="text-xs flex items-center justify-between p-2 gap-2 items-center hover:shadow-md hover:shadow-gray-200 rounded-md border border-dashed m-1 bg-white">


      <div class="w-[15px] " v-html="status(file.status)"></div>
      <div class="w-full flex gap-2 items-center"><div>{{file.name}}</div> <div v-html="statusTXT(file.status)"></div></div> 
      <div v-if="file.status == 'uploaded' || file.status == 'error'" class="text-xs cursor-pointer" @click="onDelete(file)"><XMarkIcon class="h-4 w-4 bg-gray-300 hover:bg-gray-500 rounded text-white"> </XMarkIcon></div>
  </div>
</template>

<script>
import { XMarkIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'UploadFile',

  props: {
    file: {
      type: Object,
      required: true,
    },

    onDelete: {
      type: Function,
      required: true,
    }
  },

  methods: {
    status(status) {
      switch (status) {
        case 'upload':
          return '<div class="text-gray-600">◉</div>';
        case 'uploading':
          return '<div class="text-amber-600">◉</div>';
        case 'uploaded':
          return '<div class="text-green-600">◉</div>';
        case 'error':
          return '<div class="text-rose-600">◉</div>';
        default:
          return '<div class="text-gray-600">◉</div>';
      }
    },

    statusTXT(status) {
      switch (status) {
        case 'upload':
          return '<div class="text-gray-600"></div>';
        case 'uploading':
          return '<div class="text-gray-600 text-xs flex gap-2 itens-center border rounded p-1">Enviando <img src="/imgs/loading.gif" width="15px"></div>';
        case 'uploaded':
          return '<div class="text-green-600"></div>';
        case 'error':
          return '<div class="text-rose-600">Erro ao enviar</div>';
        default:
          return '<div class="text-gray-600"></div>';
      }
    },
  },

  components: {
    XMarkIcon,
  },
}
</script>